<template>
    <li class="nav-item">
        <a
            href="#"
            :class="[ 'nav-link', { active: status === value } ]"
            @click.prevent="onClick"
        >
            <i
                class="nav-link-icon"
                :class="`far fa-${icon}`"
            />
            <slot />
        </a>
    </li>
</template>
<script>
export default {
    model: {
        event: 'change',
        prop: 'value',
    },

    props: {
        value: {
            type: String,
            default: null,
        },

        icon: {
            required: true,
            type: String,
        },

        status: {
            type: String,
            default: null,
        },
    },

    methods: {
        /**
         * Handles click event.
         */
        onClick() {
            this.$emit('change', this.status);
        },
    },
};
</script>
